@if (mode(); as current) {
  <!-- data-nosnippet: crawlers that run scripts see the banner too; keep it out of search snippets. -->
  <section
    class="consent-banner"
    [class.consent-banner--settings]="current === 'settings'"
    aria-labelledby="consent-banner-title"
    data-testid="consent-banner"
    data-nosnippet
  >
    <h2 id="consent-banner-title" class="consent-banner__title" tabindex="-1" #title>
      {{ current === 'settings' ? 'Cookie settings' : 'Cookies on Unita' }}
    </h2>
    @if (consent.configured()) {
      <p class="consent-banner__text">
        We use essential cookies to keep you signed in. With your permission, we would also like to use
        Contentsquare analytics cookies to see how people use Unita (the pages they visit, where they
        click and scroll, and recordings of their visits) so we can improve it.
        <a class="consent-banner__link" routerLink="/cookie-policy">Read our Cookie Policy</a>
      </p>
      @if (current === 'settings') {
        <p class="consent-banner__status">{{ status() }}</p>
      }
      <div class="consent-banner__actions">
        <button type="button" class="consent-banner__button" (click)="choose('granted')">Accept</button>
        <button type="button" class="consent-banner__button" (click)="choose('denied')">Reject</button>
      </div>
    }
    @if (current === 'settings' && maps.applies()) {
      <!-- 87.7b (M4; the words are the builder's: Endi's Q4) -->
      <div class="consent-banner__maps" data-testid="consent-banner-maps">
        <h3 class="consent-banner__subtitle">Maps from Google</h3>
        <p class="consent-banner__text">
          Office maps on company profiles load from Google only after you allow them. Google then receives your IP
          address and this site's address, and may set cookies.
          @if (!consent.configured()) {
            <a class="consent-banner__link" routerLink="/cookie-policy">Read our Cookie Policy</a>
          }
        </p>
        <p class="consent-banner__status">{{ mapsStatus() }}</p>
        <div class="consent-banner__actions">
          <button type="button" class="consent-banner__button" (click)="chooseMaps('granted')">Turn maps on</button>
          <button type="button" class="consent-banner__button" (click)="chooseMaps('denied')">Turn maps off</button>
        </div>
      </div>
    }
    @if (current === 'settings') {
      <button type="button" class="consent-banner__close" aria-label="Close cookie settings" (click)="close()">
        <span aria-hidden="true">&times;</span>
      </button>
    }
  </section>
}
